import UploadMassiveRules from './UploadMassiveRules';

export default UploadMassiveRules;
